/**
 * Helpers para URLs de imagens
 * - Lê base URL de imagens do .env
 * - Faz fallback para REACT_APP_API_URL e localhost
 * - Constrói URL absoluta quando receber caminho relativo
 */

const normalizeBaseUrl = (baseUrl: string): string => {
  // Remover barra à direita para evitar '//' quando concatenar
  return baseUrl.replace(/\/$/, '')
}

export const getImageBaseUrl = (): string => {
  const imageBase = process.env.REACT_APP_IMAGE_BASE_URL
  const apiBase = process.env.REACT_APP_API_URL
  const resolved = imageBase || apiBase || 'http://localhost:3001'
  return normalizeBaseUrl(resolved)
}

export const buildImageUrl = (pathOrUrl?: string): string | undefined => {
  if (!pathOrUrl) return undefined
  // Se já for absoluta, retorna como está
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl
  const base = getImageBaseUrl()
  // Garantir uma única barra entre base e caminho
  const needsSlash = pathOrUrl.startsWith('/') ? '' : '/'
  return `${base}${needsSlash}${pathOrUrl}`
}


